import api from "./api";

export async function loader() {
  const response = await api.get(`/record/`);
  return response.data;
}
